import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
  'error-message.unknown-file-type': {
    id: 'error-message.unknown-file-type',
    defaultMessage: 'Unknown file type {fileType}.',
    description:
      'The error message shown when a user tries to import a file with an unknown file type.',
  },
  'import-entries-dialog.cancel-button': {
    id: 'import-entries-dialog.cancel-button',
    defaultMessage: 'Cancel',
    description:
      'The text for the cancel button that appears when importing from html or CSV. Clicking on it exists the import dialog.',
  },
  'import-entries-dialog.import-button': {
    id: 'import-entries-dialog.import-button',
    defaultMessage: 'Import',
    description:
      'The text for the confirmation button that appears when importing html or CSV into databases.',
  },
  'import-entries-dialog.upload': {
    id: 'import-entries-dialog.upload',
    defaultMessage: 'Upload',
    description: 'The text for the Upload button where users can upload a file.',
  },
  'import-entries-dialog.upload-description-text': {
    id: 'import-entries-dialog.upload-description-text',
    defaultMessage: 'Or drag and drop your CSV and HTML files here.',
    description:
      'The text description for the import entries dialog upload step that asks the user to either use the upload button or drag and drop a file.',
  },
  'import-entries-dialog.opening-file': {
    id: 'import-entries-dialog.opening-file',
    defaultMessage: 'Opening file…',
    description: 'The text for the loading state while opening a file.',
  },
  'import-entries-dialog.import-failed': {
    id: 'import-entries-dialog.import-failed',
    defaultMessage: 'Import failed.',
    description: 'The aria label for an import failed error.',
  },
  'import-entries-dialog.configure-data': {
    id: 'import-entries-dialog.configure-data',
    defaultMessage:
      'Configure data from this file to your database and review before importing.',
    description: 'Instructions on how to import the entries after uploading the file',
  },
  'import-entries-dialog.import-file-info': {
    id: 'import-entries-dialog.import-file-info',
    defaultMessage:
      '{numberOfEntries, plural, =0 {Importing {numberOfEntries} entry from <strong>{fileName}</strong>} one {Importing {numberOfEntries} entry from <strong>{fileName}</strong>} other {Importing {numberOfEntries} entries from <strong>{fileName}</strong>}}',
    description:
      'Information about the file being imported as well as the number of entries included in each file.',
  },
  'import-entries-dialog.heading': {
    id: 'import-entries-dialog.heading',
    defaultMessage: 'Import entries',
    description: 'The heading text for the import entries dialog.',
  },
  'import-field.create-new-field-text': {
    id: 'import-field.create-new-field-text',
    defaultMessage: 'Create new text field {fieldName}',
    description:
      'The error message for importing fields when multiple columns are selected.',
  },
  'import-field.ignore-this-column-text': {
    id: 'import-field.ignore-this-column-text',
    defaultMessage: 'Ignore this column',
    description: 'The message text for importing fields to ignore this column.',
  },
  'import-field.ignore-text': {
    id: 'import-field.ignore-text',
    defaultMessage: 'Ignore this column',
    description: 'The message text for importing fields to ignore.',
  },
  'import-select-or-create-text.placeholder': {
    id: 'import-select-or-create-text.placeholder',
    defaultMessage: 'Select or create…',
    description: 'The placeholder text for a select or create dropdown.',
  },
  'import-field.error-multiple-columns-text': {
    id: 'import-field.error-multiple-columns-text',
    defaultMessage: 'Multiple columns cannot be mapped to the same field.',
    description:
      'The error message for importing fields when multiple columns are selected.',
  },
  'import-field.error-select-a-field-text': {
    id: 'import-field.error-select-a-field-text',
    defaultMessage: 'Please select a field.',
    description: 'The error message for importing fields when a field is not selected.',
  },
  'import-field-settings.field-name-inline-edit-default-text': {
    id: 'import-field-settings.field-name-inline-edit-default-text',
    defaultMessage: '{defaultFieldName} field',
    description: 'The default field name for a field name.',
  },
  'import-field-settings.type-text': {
    id: 'import-field-settings.type-text',
    defaultMessage: 'Text',
    description:
      'The text associated with the dropdown menu button for the Text database field type.',
  },
});
